module.exports = __webpack_public_path__ + "static/img/reimaging-onboarding-data08.c5ae90d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details-page/reimaging-onboarding-data08.png
// module id = /6Iz
// module chunks = 1